import { useEffect } from 'react';
import { generatePath, Outlet, useNavigate, useParams } from 'react-router-dom';
import { tr } from '@repo/locale';
import { TestId } from '@repo/test-id';
import { toast } from '@repo/toast';

import { useParkingContext } from '@features/ownedParkingManage/contexts/ParkingContext';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function ParkingBillingExistsGuard() {
  const { id: parkingId } = useParams<{ id: string }>();
  const parking = useParkingContext();
  const navigate = useNavigate();

  const billing = parking.billing;

  useEffect(() => {
    if (!billing) {
      const testId = TestId.root('parkingBillingExistsGuardError');
      toast.danger(tr('owned_parking_manage:manage.billing.error.not_found'), testId);
      navigate(generatePath(ROUTE_PATHS[RouteName.MY_PARKING_MANAGE_BILLING_SELECTION], { id: parkingId }), {
        replace: true,
      });
    }
  }, [billing, navigate, parkingId]);

  if (!billing) {
    return null;
  }

  return <Outlet context={billing} />;
}
